const sendEvent = (googleAnalytics, data) => {
  if (!googleAnalytics || !googleAnalytics.event) {
    return
  }
  return googleAnalytics.event({
    ...data,
    category: data.eventCategory || data.category,
    action: data.eventAction || data.action,
    label: data.eventLabel || data.label,
    value: data.pozice
  })
}

module.exports = {
  sendEvent
}
